import React from "react";
import { Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { PagePrint } from "../PagePrint";
import { ORDER_TYPE_OPTIONS, ORDER_TYPES } from "../../constants/orders";
import { QuoteCalcTable, QuoteItemsTable } from "../../tables";

import CompanyInfo from "./CompanyInfo";
import SignatureSection from "./SignatureSection";
import { TablesStack } from "./styles";
import QuoteMargins from "./QuoteMargins";
import CostingAttachmentsPage from "./CostingAttachmentsPage";
import { CustomerQuoteDocument } from "../CustomerQuoteDocument";
import { HubHookFormInput } from "../HubHookFormInput";
import { StyledItemRow } from "../../tables/QuoteItemsTable/styles";

export const QuoteDocument = ({
  id,
  quoteNumber,
  location,
  createdById,
  shipDate,
  showCosting = true,
  showQuote = true,
}) => {
  const { watch } = useFormContext();
  const type = watch("type") || ORDER_TYPES.MATERIALS;
  const orderType = ORDER_TYPE_OPTIONS.find(({ id }) => id === type);

  return (
    <Stack
      gap="25px"
      className="print-only"
      sx={{ ".print-only": { boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.2)" } }}
    >
      <Stack sx={{ display: showCosting ? "flex" : "none" }}>
        <PagePrint cardProps={{ id: "page-1", sx: { position: "relative" } }}>
          <CompanyInfo
            location={location}
            number={id}
            shipDate={shipDate}
            quoteNumber={quoteNumber}
          />
          <TablesStack>
            <QuoteItemsTable {...orderType} />
            <QuoteCalcTable {...orderType} />
          </TablesStack>
          <StyledItemRow
            sx={{
              border: "1px solid",
              borderColor: "hubColors.grey",
              padding: 0,
            }}
          >
            <Stack gridColumn="span 2" gridRow="span 3" height="100%">
              <HubHookFormInput
                name="notes"
                placeholder="Notes..."
                shouldUnregister={false}
                
                disableHelperText
                multiline
                rows={3}
                className="isLast"
              />
            </Stack>
          </StyledItemRow>
          <QuoteMargins />
          <SignatureSection createdById={createdById} />
        </PagePrint>
      </Stack>
      <CostingAttachmentsPage quoteId={id} />
      <Stack sx={{ display: showQuote ? "flex" : "none" }}>
        <CustomerQuoteDocument />
      </Stack>
    </Stack>
  );
};

export default QuoteDocument;
